import styled, { css } from 'styled-components';
import Text12 from '@sdk/components/ui/typography/Text12';

export const SearchItemWrapper = styled.article`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 2px;
  margin-bottom: 20px;
  transition: box-shadow 0.2s linear;

  &:hover {
    box-shadow: 0 5px 10px ${({ theme }) => theme.colors.boxShadowDarker};
  }

  .search-match {
    background: #fdf1c6;
    border-radius: 2px;
    padding: 0 3px;
  }
`;

export const SeeMoreButtonText = styled(Text12)`
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const ArticleSpacing = css`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 30px 30px 20px 30px;
`;

export const SearchArticleWrapper = styled.div`
  cursor: pointer;
  ${ArticleSpacing}
`;

export const SearchArticleFooter = styled.div`
  ${ArticleSpacing};
  padding-top: 0;
`;
